<template>
  <div v-if="currentOffre">
    <!--div class="row">
      <div class="col-lg-6">
        <BreadCrumd
          :title="'Candidatures'"
          :description="'Nouvelle candidature'"
        />
      </div>
      <div class="col-lg-6 mt-lg-4" v-if="currentCandidature.offre">
        <div class="row">
          <div class="col-md-12">
            <table
              class="card table table-sm table-custom-primary table-bordered mb-0"
            >
              <tbody>
                <tr class="d-flex">
                  <td class="col-12 font-size-17 text-center font-weight-bold">
                    Offre concernée
                  </td>
                </tr>
                <tr class="d-flex font-size-17 font-weight-bold">
                  <td
                    class="col-12 text-custom-primary d-flex justify-content-between px-2"
                  >
                    <span>Référence :</span>
                    <span>
                      <router-link
                        :to="{
                          name: 'rh_offre_emploi-show',
                          params: { id: currentCandidature.offre.id },
                        }"
                        class="mr-4"
                        title="Aperçu"
                      >
                        <i
                          class="fa fa-eye text-custom-primary font-size-17"
                        ></i>
                        <u class="text-custom-primary">
                          {{ currentCandidature.reference_offre }}</u
                        >
                      </router-link>
                    </span>
                  </td>
                </tr>
                <tr class="d-flex font-size-17 font-weight-bold">
                  <td
                    class="col-12 text-custom-primary d-flex justify-content-between px-2"
                  >
                    <span>Période :</span>
                    <span
                      >{{
                        currentCandidature.offre.date_debut
                          | formatDate('DD/MM/YYYY')
                      }}
                      -
                      {{
                        currentCandidature.offre.date_fin
                          | formatDate('DD/MM/YYYY')
                      }}</span
                    >
                  </td>
                </tr>
                <tr class="d-flex font-size-17 font-weight-bold">
                  <td
                    class="col-12 text-custom-primary d-flex justify-content-between px-2"
                  >
                    <span>Poste :</span>
                    <span>{{ currentCandidature.poste }}</span>
                  </td>
                </tr>

                <tr class="d-flex font-size-17 font-weight-bold">
                  <td
                    class="col-12 text-custom-primary d-flex justify-content-between px-2"
                  >
                    <span>Nombre de poste :</span>
                    <span>{{ currentCandidature.offre.nbre_poste }}</span>
                  </td>
                </tr>
              </tbody>
            </table>
            <br />
            <table
              class="card table table-sm table-custom-primary table-bordered mb-0"
            >
              <tbody>
                <tr class="d-flex font-size-17 font-weight-bold">
                  <td class="col-6 text-custom-primary">
                    Référence :
                    {{ currentCandidature.document.reference }}
                  </td>
                  <td class="col-6">
                    Statut :
                    <i
                      class="mdi mdi-checkbox-blank-circle mr-1"
                      :class="{
                        'text-warning':
                          currentCandidature.statut === CONST.EN_ATTENTE,
                        'text-success':
                          currentCandidature.statut === CONST.VALIDER,
                        'text-danger':
                          currentCandidature.statut === CONST.REFUSER,
                      }"
                    ></i>
                    {{ getStatutCA(currentCandidature.statut) }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div-->

    <div class="row">
      <div class="col-lg-6">
        <BreadCrumd
          :title="'Candidatures'"
          :description="'Nouvelle candidature'"
        />
      </div>
      <div class="col-lg-6 mt-lg-4">
        <div class="row">
          <div class="col-md-12">
            <table
              class="card table table-sm table-custom-primary table-bordered mb-0"
            >
              <tbody>
                <tr class="d-flex font-size-17">
                  <td class="col-12 text-center font-weight-bold">
                    Offre d'emploi concernée
                  </td>
                </tr>
                <tr class="d-flex font-size-17 font-weight-bold">
                  <td
                    class="col-6 text-custom-primary d-flex justify-content-between"
                  >
                    <div>Référence : {{ currentOffre.document.reference }}</div>
                    <div>
                      <router-link
                        :to="{
                          name: 'rh_offre_emploi-show',
                          params: { id: currentOffre.id },
                        }"
                        title="Aperçu"
                      >
                        <i
                          class="fa fa-eye text-custom-primary font-size-17"
                        ></i>
                      </router-link>
                    </div>
                  </td>
                  <td class="col-6 font-weight-bold">
                    Poste : {{ currentOffre.poste.nom }}
                  </td>
                </tr>
                <tr class="d-flex">
                  <td class="col-6 font-weight-bold">
                    Période :
                    {{ currentOffre.date_debut }}
                    -
                    {{ currentOffre.date_fin }}
                  </td>
                  <td class="col-6 font-weight-bold">
                    Nombre de poste :
                    {{ currentOffre.nbre_poste }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

    <div class="row mt-4">
      <div class="col-md-12 col-lg-6">
        <button
          type="button"
          class="btn btn-secondary mr-4"
          @click.prevent="$router.push(prov).catch(() => {})"
        >
          Liste des candidatures
        </button>
      </div>
    </div>

    <div class="mt-4 mb-4">
      <form @submit.prevent="submit" @keydown="form.onKeydown($event)">
        <alert-error
          v-if="form.errors.get('message')"
          :form="form"
          :message="form.errors.get('message')"
        ></alert-error>
        <div class="row">
          <div class="col-md-12">
            <div class="card">
              <div class="card-body mb-n2">
                <div class="row">
                  <div class="col-md-6 col-lg-4">
                    <div class="form-group">
                      <label for="nom"
                        >Nom <span class="text-danger">*</span></label
                      >
                      <input
                        class="form-control"
                        :class="{ 'is-invalid': form.errors.has('nom') }"
                        id="nom"
                        v-model="form.nom"
                        type="text"
                        placeholder="Nom"
                        maxlength="50"
                        required
                      />
                      <has-error :form="form" field="nom"></has-error>
                    </div>
                  </div>
                  <div class="col-md-6 col-lg-4">
                    <div class="form-group">
                      <label for="prenom">Prénom</label>
                      <input
                        class="form-control"
                        :class="{ 'is-invalid': form.errors.has('prenom') }"
                        id="prenom"
                        v-model="form.prenom"
                        type="text"
                        placeholder="Prénom"
                        maxlength="50"
                      />
                      <has-error :form="form" field="prenom"></has-error>
                    </div>
                  </div>
                  <div class="col-md-6 col-lg-4 mt-n2 mt-md-0">
                    <div class="form-group">
                      <label for="date_naissance">Date naissance</label>
                      <date-picker
                        v-model="form.date_naissance"
                        name="date_naissance"
                        placeholder="Date naissance"
                        lang="fr"
                        format="DD/MM/YYYY"
                        value-type="DD/MM/YYYY"
                      ></date-picker>
                      <input
                        class="form-control"
                        :class="{
                          'is-invalid': form.errors.has('date_naissance'),
                        }"
                        type="hidden"
                      />
                      <has-error
                        :form="form"
                        field="date_naissance"
                      ></has-error>
                    </div>
                  </div>
                  <div class="col-md-6 col-lg-4">
                    <div class="form-group">
                      <label for="lieu_naissance">Lieu naissance</label>
                      <input
                        class="form-control"
                        :class="{
                          'is-invalid': form.errors.has('lieu_naissance'),
                        }"
                        id="lieu_naissance"
                        v-model="form.lieu_naissance"
                        type="text"
                        placeholder="Lieu naissance"
                        maxlength="50"
                      />
                      <has-error
                        :form="form"
                        field="lieu_naissance"
                      ></has-error>
                    </div>
                  </div>
                  <div class="col-md-6 col-lg-4">
                    <div class="form-group">
                      <label for="pays_naissance">Pays naissance</label>
                      <input
                        class="form-control"
                        :class="{
                          'is-invalid': form.errors.has('pays_naissance'),
                        }"
                        id="pays_naissance"
                        v-model="form.pays_naissance"
                        type="text"
                        placeholder="Pays naissance"
                        maxlength="50"
                      />
                      <has-error
                        :form="form"
                        field="pays_naissance"
                      ></has-error>
                    </div>
                  </div>
                  <div class="col-md-6 col-lg-4">
                    <div class="form-group">
                      <label for="nationalite">Nationalité</label>
                      <input
                        class="form-control"
                        :class="{
                          'is-invalid': form.errors.has('nationalite'),
                        }"
                        id="nationalite"
                        v-model="form.nationalite"
                        type="text"
                        placeholder="Nationalité"
                        maxlength="50"
                      />
                      <has-error :form="form" field="nationalite"></has-error>
                    </div>
                  </div>
                  <div class="col-md-6 col-lg-4">
                    <div class="form-group">
                      <label for="adresse">Adresse</label>
                      <input
                        class="form-control"
                        :class="{
                          'is-invalid': form.errors.has('adresse'),
                        }"
                        id="adresse"
                        v-model="form.adresse"
                        type="text"
                        placeholder="Adresse"
                        maxlength="150"
                      />
                      <has-error :form="form" field="adresse"></has-error>
                    </div>
                  </div>
                  <div class="col-md-6 col-lg-4">
                    <div class="form-group">
                      <label for="ville">Ville</label>
                      <input
                        class="form-control"
                        :class="{
                          'is-invalid': form.errors.has('ville'),
                        }"
                        id="ville"
                        v-model="form.ville"
                        type="text"
                        placeholder="Ville"
                        maxlength="50"
                      />
                      <has-error :form="form" field="ville"></has-error>
                    </div>
                  </div>
                  <div class="col-md-6 col-lg-4">
                    <div class="form-group">
                      <label for="email"
                        >Email <span class="text-danger">*</span></label
                      >
                      <input
                        class="form-control"
                        :class="{
                          'is-invalid': form.errors.has('email'),
                        }"
                        id="email"
                        v-model="form.email"
                        type="text"
                        placeholder="Email"
                        maxlength="50"
                      />
                      <has-error :form="form" field="email"></has-error>
                    </div>
                  </div>
                  <div class="col-md-6 col-lg-4">
                    <div class="form-group">
                      <label for="telephone">Téléphone</label>
                      <input
                        class="form-control"
                        :class="{
                          'is-invalid': form.errors.has('telephone'),
                        }"
                        id="telephone"
                        v-model="form.telephone"
                        type="text"
                        placeholder="Téléphone"
                        maxlength="50"
                      />
                      <has-error :form="form" field="telephone"></has-error>
                    </div>
                  </div>
                  <div class="col-md-6 col-lg-4">
                    <div class="form-group">
                      <label for="statut"
                        >Statut de la candidature
                        <span class="text-danger">*</span></label
                      >
                      <v-custom-select
                        label="nom"
                        :options="statuts"
                        :reduce="(statut) => statut.uuid"
                        v-model="form.statut"
                        placeholder="Statut de la candidature"
                      >
                        <template v-slot:option="{ nom, couleur }">
                          <h5 style="margin: 0">
                            <i
                              :style="`color: ${couleur}`"
                              class="fa fa-circle mr-1"
                            ></i>
                            {{ nom }}
                          </h5>
                        </template>
                        <template #no-options> Aucune donnée </template>
                        <template #search="{ attributes, events }">
                          <input
                            id="statut"
                            class="custom-select-height vs__search"
                            v-bind="attributes"
                            v-on="events"
                          />
                        </template>
                      </v-custom-select>
                      <div>
                        <input
                          type="hidden"
                          class="form-control"
                          :class="{
                            'is-invalid': form.errors.has('statut'),
                          }"
                        />
                        <has-error :form="form" field="statut"></has-error>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row mb-4 mt-2">
          <div class="col-md-12 text-right">
            <ButtonLoader
              :busy="form.busy"
              type="submit"
              customClass="btn btn-custom-primary w-40"
              loadText="Traitement en cours..."
              Text="Créer"
              style="min-width: 100px"
            ></ButtonLoader>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import URL_C from '@/http/rh/candidature/candidature';
import URL_O from '@/http/rh/offre-emploi';
import Form from 'vform';
import DatePicker from 'vue2-datepicker';
import VueEditorToolbar from '@/vue-editor-tool-bar';
import { mapActions } from 'vuex';
import { mapGetters } from 'vuex';

export default {
  data() {
    return {
      form: new Form({
        nom: '',
        prenom: '',
        date_naissance: '',
        lieu_naissance: '',
        pays_naissance: '',
        ville: '',
        nationalite: '',
        adresse: '',
        email: '',
        telephone: '',
        offre: '',
        statut: '',
      }),
      id: null,
      VueEditorToolbar,
      prov: this.$route.params.prov,
      statuts: [],
      title: 'Gestion des candidatures - Création',
    };
  },
  watch: {
    $route() {
      this.init();
    },
  },
  computed: {
    ...mapGetters('offreEmploi', ['currentOffre']),
  },
  components: {
    DatePicker,
  },
  metaInfo() {
    return {
      title: this.title,
      titleTemplate: this.titleApp + ' | %s',
    };
  },
  methods: {
    ...mapActions('offreEmploi', ['setCurrentOffre']),
    init() {
      this.id = this.$route.params.id;
      this.setCurrentOffre(null);
      this.statuts = [];

      if (this.$route.params.filter === 'cloner') {
        window.axios
          .all([
            window.axios.get(
              URL_O.OFFRE_EMPLOI + '/' + this.$route.params.offreId
            ),
            window.axios.get(URL_C.CANDIDATURE + '/' + this.id, {
              params: {
                edit: true,
              },
            }),
            window.axios.get(URL_C.GET_REQUIREMENTS),
          ])
          .then(
            window.axios.spread((resp1, resp2, resp3) => {
              this.setCurrentOffre(resp1.data.offre_emploi);
              Object.assign(this.form, resp2.data.candidature);
              this.statuts = resp3.data.statuts;
              delete this.form.id;
              delete this.form.uuid;
            })
          )
          .catch();
      } else {
        window.axios
          .all([
            window.axios.get(
              URL_O.OFFRE_EMPLOI + '/' + this.$route.params.offreId
            ),
            window.axios.get(URL_C.GET_REQUIREMENTS),
          ])
          .then(
            window.axios.spread((resp1, resp2) => {
              this.setCurrentOffre(resp1.data.offre_emploi);
              this.statuts = resp2.data.statuts;
            })
          )
          .catch();
      }
    },

    submit() {
      this.form.offre = this.currentOffre.uuid;

      this.form
        .post(URL_C.CANDIDATURE)
        .then((resp) => {
          this.showSimpleAlerte('top-end', 'success', resp.data.message);
          this.form.reset();
          if (this.id) {
            this.id = null;
          }
          this.$router.push({
            name: 'rh_candidature-show',
            params: {
              id: resp.data.candidature.id,
              offreId: this.currentOffre.id,
              prov: this.prov,
            },
          });
        })
        .catch((err) => {
          this.form.errors.set('message', err.response.data.message);
        });
    },
  },
  mounted() {
    this.init();
  },
};
</script>

<style scoped></style>
